import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function CTASection() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  const { ref, visible } = useScrollReveal();

  return (
    <section id="contact" className="py-20 bg-olive-500">
      <div ref={ref} className={`mx-auto px-4 md:px-6 max-w-4xl text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-7'}`}>
        <p className="text-sm font-semibold tracking-wide text-olive-100 uppercase mb-3">
          Ready When You Are
        </p>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to Create More Freedom
          <br />
          for Your Family?
        </h2>
        <p className="text-olive-100 text-base mb-10 max-w-xl mx-auto">
          Let's connect and explore which path is right for you. No pressure —
          just a genuine conversation about your family's goals.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <a
            href="https://calendly.com/carol-berry305"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-white hover:bg-olive-50 text-olive-600 font-semibold px-8 py-3.5 rounded-full text-base transition-all hover:scale-105 cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="fas fa-calendar-alt text-sm"></i>
            </span>
            Book a Free Call
          </a>
          <button
            onClick={() => handleScroll("#paths")}
            className="whitespace-nowrap inline-flex items-center gap-2 border border-white/60 text-white hover:bg-white/10 font-semibold px-8 py-3.5 rounded-full text-base transition-all hover:scale-105 cursor-pointer"
          >
            Learn More First
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="fas fa-arrow-right text-sm"></i>
            </span>
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          <div className="text-center">
            <p className="font-heading text-4xl font-bold text-white mb-1">
              500+
            </p>
            <p className="text-olive-100 text-sm">Families Helped</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-4xl font-bold text-white mb-1">
              $400+
            </p>
            <p className="text-olive-100 text-sm">Avg Monthly Income</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-4xl font-bold text-white mb-1">
              98%
            </p>
            <p className="text-olive-100 text-sm">Would Recommend</p>
          </div>
        </div>
      </div>
    </section>
  );
}